import { InjectionToken } from '@angular/core';

export interface StorageSettings {
	get appStorageScopeKey(): string;

	get tokenStorageKey(): string;
}

export const StorageSettingsToken = new InjectionToken<StorageSettings>('StorageSettings');
